export const isMobileBrowser = () => {
  return 'ontouchstart' in document.documentElement && /mobi/i.test(navigator.userAgent);
};

export const isMobile = () => {
  const root = document.querySelector(':root');
  if (root) {
    // const rootStyles = getComputedStyle(root);
    const bodyStyles = document.body.style;
    const appMobileMode = bodyStyles.getPropertyValue('--app-mode-mobile');
    return Boolean(appMobileMode === 'true');
  }

  /**
 Alternative approach to determine if the app is in mobile mode by checking the root CSS variable.
 ```typescript
 const root = document.querySelector(':root');
 if (root) {
  const rootStyles = getComputedStyle(root);
  const appMobileMode = rootStyles.getPropertyValue('--app-mode-mobile');
  console.log(`${Emojis.eyes} AppMobileMode %c ${appMobileMode} %c`, ValueLgCls, '');
 }
 ```
 */

  const container = document.getElementById('root');
  if (container) {
    const cardRect: DOMRect = container.getBoundingClientRect();
    return cardRect.width < 450;
  }
  return false;
};

export const convertToCelsius = (tempInFahrenheit: number): number => {
  return Math.round(((tempInFahrenheit - 32) * 5) / 9);
};
